import {
  useCallback, useEffect, useRef, useState,
} from 'react';
import { REVIEW_TRANSITION_DELAY_MS } from 'constants/general';

const useReviewTransitionLoading = () => {
  const [isReviewTransitionLoading, setIsReviewTransitionLoading] = useState(false);
  const reviewTransitionTimeoutRef = useRef<number | null>(null);

  useEffect(() => () => {
    if (reviewTransitionTimeoutRef.current !== null) {
      window.clearTimeout(reviewTransitionTimeoutRef.current);
    }
  }, []);

  const startReviewTransitionLoading = useCallback(() => {
    setIsReviewTransitionLoading(true);

    return Date.now();
  }, []);

  const clearReviewTransitionLoading = useCallback(() => {
    if (reviewTransitionTimeoutRef.current !== null) {
      window.clearTimeout(reviewTransitionTimeoutRef.current);
      reviewTransitionTimeoutRef.current = null;
    }

    setIsReviewTransitionLoading(false);
  }, []);

  const finishReviewTransitionLoading = useCallback((startedAt: number | null) => {
    if (startedAt == null) {
      return Promise.resolve();
    }

    const elapsed = Date.now() - startedAt;
    const remainingDelay = Math.max(REVIEW_TRANSITION_DELAY_MS - elapsed, 0);

    if (remainingDelay === 0) {
      setIsReviewTransitionLoading(false);
      return Promise.resolve();
    }

    return new Promise<void>((resolve) => {
      reviewTransitionTimeoutRef.current = window.setTimeout(() => {
        reviewTransitionTimeoutRef.current = null;
        setIsReviewTransitionLoading(false);
        resolve();
      }, remainingDelay);
    });
  }, []);

  return {
    isReviewTransitionLoading,
    startReviewTransitionLoading,
    clearReviewTransitionLoading,
    finishReviewTransitionLoading,
  };
};

export default useReviewTransitionLoading;
